import { Flex, Heading, Text, Stack } from "@chakra-ui/react";

export default function SupervisorCounters({
	contador1_numero,
	contador1_titulo,
	contador2_numero,
	contador2_titulo,
	contador3_numero,
	contador3_titulo,
}) {
	const counters = [
		{
			numero: contador1_numero,
			titulo: contador1_titulo,
		},
		{
			numero: contador2_numero,
			titulo: contador2_titulo,
		},
		{
			numero: contador3_numero,
			titulo: contador3_titulo,
		},
	].filter((c) => c.numero && c.titulo);

	if (counters.length === 0) return null;

	return (
		<Flex position="absolute" right="5" gap={4}>
			{counters.map((c, idx) => (
				<Stack key={idx} alignItems="center" gap={0}>
					<Heading fontSize="20px" color="#fed700" m={0}>
						{c.numero}
					</Heading>
					<Text fontSize="14px" color="#fff" whiteSpace="nowrap">
						{c.titulo}
					</Text>
				</Stack>
			))}
		</Flex>
	);
}
